import Page from 'src/apipages/upload/texttracks/index';

export default Page;
